<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">Logs/Comments</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body table-responsive p-0 table-striped table-hover table-bordered">
                <table class="table table-head-fixed table-hover-animation text-nowrap">
                  <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Assigned By</th>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Sub Department</th>
                    <th>Comment</th>
                    <th>Date</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(row, index) in list">
                    <td>{{ index + 1 }}</td>
                    <td>{{ row.assignedBy.name}}</td>
                    <td v-if="row.assignedTo">{{ row.assignedTo.name}}</td>
                    <td v-else></td>
                    <td v-if="row.status == 0"><span class="badge badge-light-success badge-glow badge-sm">Open</span></td>
                    <td v-else-if="row.status == 1"><span class="badge badge-light-warning badge-glow badge-sm">Close</span></td>
                    <td v-else ><span class="badge badge-light-danger badge-glow badge-sm">Final Close</span></td>
                    <td>{{row.subDepartment?row.subDepartment.name:''}}</td>
                    <td>{{ row.comments }}</td>
                    <td>{{ new Date(row.createdAt).toISOString().slice(0, 16).replace("T", " ") }}</td>
                  </tr>
                  <tr v-if="list.length == 0">
                    <td
                        colspan="11"
                        class="font-weight-bolder font-medium-2"
                        style="text-align: center"
                    >
                      <div class="spinner-border spinner-border-sm text-primary" v-show="loading" ></div>
                      No data avaliable
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["show", "data", "index"],
  data() {
    return {
      list: [],
      loading: false,
      // showModal: false,
    };
  },
  methods:{
    resolveStatusUpdatedBy(row){
      if(!row.status_updated_by || row.status_updated_by == 0){
        return 'Auto Initiated'
      }
      if(row.updated_by){
        return row.updated_by.email + '/' + row.updated_by.first_name
      }

      return ''

    },
    getLogs()
    {
      let url = 'v1/cms-get-case-status'
      this.loading = true
      this.makeRequest("post", url, {caseId: this.data?.id,limit: 0}, {}, false).then(callResponse => {
        this.loading = false;
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          this.list = callResponse.response?.data?.data
          // if (code == 200) {
          //   this.$emit('completed',callResponse.response.data.data)
          // }
        }
      });
    }
  },
  watch: {
    show(val) {
      if(val){
        this.getLogs()
      }
      this.$nextTick(() => {
        this.list =  []
      })
    },
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

